"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MediaItemType;
(function (MediaItemType) {
    MediaItemType["image"] = "image";
    MediaItemType["video"] = "video";
    MediaItemType["audio"] = "audio";
    MediaItemType["document"] = "document";
    MediaItemType["zip"] = "zip";
})(MediaItemType = exports.MediaItemType || (exports.MediaItemType = {}));
var CouponType;
(function (CouponType) {
    CouponType["BuyXGetY"] = "BuyXGetY";
    CouponType["FixedPrice"] = "FixedPriceAmount";
    CouponType["FreeShipping"] = "FreeShipping";
    CouponType["MoneyOff"] = "MoneyOffAmount";
    CouponType["PercentOff"] = "PercentOffRate";
})(CouponType = exports.CouponType || (exports.CouponType = {}));
//# sourceMappingURL=defenitions.js.map